// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__9t3rk","hidearrow":"Sidebar_hidearrow__ivhNi"};